import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const ProfileMenuLoginButton = styled(Button).attrs({
  appearance: 'secondaryLight',
  hasPadding: false,
  borderRadius: 14,
  isBodyFontFamily: true,
})`
  min-width: 86px;
  padding: 13px 15px;
  line-height: 1.25;

  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.background};
  }
`;
